module.exports = __webpack_public_path__ + "img/slswa.daa9908.png";